import * as Users from "js/common/users";
import * as Groups from "js/common/groups";
import {indexBy} from "js/common/utils/collections";

export const getCurrentUserPermissionForConfig = (savedConfig) => {
  const currentUser = Users.getCurrentUser();
  const userPermission = savedConfig.getIn(["sharedWith", "users"])
      .find(g => g.get("id") === currentUser.get("id"))
      ?.get("permission");

  if (userPermission) {
    return userPermission;
  }

  const groupHierarchy = Groups.getGroupBreadcrumbs(currentUser.get("groupId")).map(g => g.id).reverse();
  const groupIdToPermission = indexBy(g => g.get("id"), savedConfig.getIn(["sharedWith", "groups"]))
      .map(g => g.get("permission"));

  let groupPermission = null;
  for (let groupId of groupHierarchy) {
    const permission = groupIdToPermission.get(groupId);
    if (permission) {
      groupPermission = permission;
      break;
    }
  }
  return groupPermission;
};